import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LinkAboutBgtComponent } from '../shared/link-about-bgt/link-about-bgt.component';
import { LinkAboutBgtViewerComponent } from '../shared/link-about-bgt-viewer/link-about-bgt-viewer.component';
import { LinkBgtWfsComponent } from '../shared/link-bgt-wfs/link-bgt-wfs.component';
import { CallToActionComponent } from '../shared/call-to-action/call-to-action.component';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss'],
    imports: [RouterLink, LinkAboutBgtComponent, LinkAboutBgtViewerComponent, LinkBgtWfsComponent, CallToActionComponent]
})
export class DownloadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
